export default __webpack_public_path__ + "static/media/icon_errorIE.cad9088e.svg";